import { useEffect, useState } from "react";
import { useApi } from "utils";
import { DataResourcesType } from "../types/ResourcesTypes";

export type SuccessFetch = {
status: string;
responseStatus: number;
message: string;
payload:DataResourcesType[]
};

export function useResourcesDetail(project_id?: string) {
    const api = useApi();
    const [detailResources, setData] = useState<DataResourcesType[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchData = async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await api.get(`/project/get-project-resources`, {
                params: { project_id: project_id },
            });
            const response: SuccessFetch = res.data;
            setData(response.payload);       
            setLoading(false);     
        } catch (err: any) {
            setError(err?.response?.data?.message || "Failed to fetch data");
            setData([]);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const refetchResources = () => fetchData()

    useEffect(() => {
        // jangan fetch kalau tidak ada id (mode create)
        if (!project_id) return;
        fetchData();
         // eslint-disable-next-line
    }, [project_id]);

    return { 
        detailResources, 
        loading, 
        error, 
        refetchResources
    };
}
